<template>
    <div class='layer-pop alert-pop'>
        <div class='view-content'>
            <div class='view-area' 
                :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
            </div>
            <div class='body-area'>
                <p class='body'> {{ body1 }}</p>
                <p class='body'> {{ body2 }}</p>
            </div>
            <button @click='onClickBtnCancel' class='close-text'>확인</button>
            <p v-if='isTimeLimit' class='time-limit'>
                {{limitTime}}초 후 초기 화면으로 돌아갑니다.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'imageAlert',
    props: {
        imgUrl: {
            type: String,
        },
        body1: {
            type: String,
        },
        body2: {
            type: String,
        },
        isTimeLimit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            limitTime: 5,
        };
    },
    mounted() {
        // 자동 팝업 닫힘
        if(this.isTimeLimit) {
            let timer = setInterval(() => {
                this.limitTime--;
                if(this.limitTime == 0) {
                    clearInterval(timer);
                    this.$emit('close-popup');
                }
            }, 1000);
        }
    },
    methods: {
        onClickBtnCancel() {
            this.$emit('close-popup');
        },
    },
};
</script>

<style lang='scss' scoped>

    .time-limit {
        margin-top: 16px;
        font-family: Noto Sans CJK KR;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 2.4rem;
        letter-spacing: -0.6000000238418579px;
        text-align: center;
        color: #777777;
    }

</style>
